import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  id: "step-header",
  class: "breadcrumb"
}
const _hoisted_2 = {
  key: 0,
  class: "msg"
}
const _hoisted_3 = {
  key: 1,
  class: "msg error"
}
const _hoisted_4 = {
  key: 2,
  class: "msg"
}
const _hoisted_5 = {
  key: 3,
  class: "dashboard-wrapper"
}
const _hoisted_6 = { class: "popup-card" }
const _hoisted_7 = {
  class: "status",
  style: {"display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "label-row"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  class: "popup-actions",
  style: {"margin-top":"8px","display":"flex","gap":"8px"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "pill-label" }
const _hoisted_15 = ["title", "aria-label"]
const _hoisted_16 = {
  id: "step-table",
  class: "tbl-wrap"
}
const _hoisted_17 = { class: "tbl" }
const _hoisted_18 = { class: "header-content" }
const _hoisted_19 = { class: "header-content" }
const _hoisted_20 = { class: "search-row" }
const _hoisted_21 = { colspan: "9" }
const _hoisted_22 = { class: "search-container" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "mono" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "actions" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick", "title"]
const _hoisted_29 = {
  key: 0,
  class: "label-row"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "mono" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  colspan: "9",
  class: "msg-row",
  style: {"text-align":"center","padding":"24px","color":"#666","background":"#fff"}
}
const _hoisted_38 = {
  key: 0,
  class: "pagination-controls"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "pagination-jump" }
const _hoisted_42 = ["max"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 4,
  class: "modal-mask"
}
const _hoisted_46 = { class: "modal" }
const _hoisted_47 = { style: {"margin":"6px 0 18px"} }
const _hoisted_48 = { class: "status-options" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "modal-actions" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]

import axios from "@/axiosInstance";
import dayjs from "dayjs";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// @ts-ignore
import { ec as EC } from "elliptic";
import { Buffer } from "buffer";
// Polyfill Buffer for browser if needed, though vite usually handles it, or use Uint8Array
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
	faLocationCrosshairs,
	faArrowsUpDownLeftRight,
	faAngleLeft,
	faAngleRight,
	faAnglesLeft,
	faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";

// Lucide icons
import {
	ChevronDown as ChevronDownIcon,
	ChevronUp as ChevronUpIcon,
	Database as DataIcon,
	X as CloseIcon,
} from "lucide-vue-next";
import { io } from "socket.io-client";
import router from "@/router";
import { WS_URL } from "@/config";
import {
	computed,
	inject,
	nextTick,
	onBeforeUnmount,
	onMounted,
	ref,
	watch,
} from "vue";
import { useToast } from "vue-toast-notification";
import NotificationBell from "./NotificationBell.vue";

import PermissionRequestModal from "@/components/PermissionRequestModal.vue";
import LocationModal from "@/components/data/LocationModal.vue";

import "leaflet.markercluster"; // 3️⃣  estende L con MarkerClusterGroup
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// Vue-Leaflet components
import {
	LIcon,
	LMap,
	LMarker,
	LPopup,
	LTileLayer,
	LTooltip,
} from "@vue-leaflet/vue-leaflet";
import { LMarkerClusterGroup } from "vue-leaflet-markercluster";
import "vue-leaflet-markercluster/dist/style.css";

// Fix per le icone mancanti in produzione
import type { LatLng, Marker as LeafletMarker } from "leaflet";
import type { ComponentPublicInstance, Ref } from "vue";

/** istanza Vue di <l-marker> con accessor leafletObject tipizzato */
type MarkerComponent = ComponentPublicInstance & {
	leafletObject: LeafletMarker;
};

/** istanza Vue di <l-marker-cluster-group> */
type ClusterComponent = ComponentPublicInstance & {
	leafletObject: L.MarkerClusterGroup;
};

// reference per mappa cluster dei marker
const shadowUrl =
	"https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png";

// Aggiunge coordinate ai dispositivi

export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

globalThis.Buffer = Buffer;

const isDesktop = inject<Ref<boolean>>("isDesktop")!;
const isSidebarOpen = inject<Ref<boolean>>("isSidebarOpen")!;

const mapCollapsed = ref(false);

// Location Edit Modal State
const showLocationModal = ref(false);
const locationModalDevice = ref<any | null>(null);

function openLocationModal(device: any) {
	locationModalDevice.value = device;
	showLocationModal.value = true;
}

async function copyLocationCoords() {
	if (!locationModalDevice.value?.location) return;
	const [lat, lng] = locationModalDevice.value.location;
	try {
		await navigator.clipboard.writeText(`${lat.toFixed(6)}, ${lng.toFixed(6)}`);
		toast.success("Coordinate copiate!", { duration: 2000 });
	} catch {
		toast.error("Impossibile copiare le coordinate.", { duration: 2000 });
	}
}

// Permission Modal State
const showPermissionModal = ref(false);
const permissionDevice = ref<any | null>(null);
const failedPermissionType = ref<
	"change_status" | "change_mode" | "change_thresholds"
>("change_mode");

// soglie con isteresi
const COLLAPSE_AT = isDesktop.value ? 260 : 180;
const EXPAND_AT = isDesktop.value ? 120 : 60;

let ticking = false;

const showCrumbBell = computed(
	() => !isDesktop.value || (isDesktop.value && !isSidebarOpen.value),
);

/* ─── stato utente ─── */
const me = ref<any>({});
const isAdmin = computed(() => me.value.is_admin);

/* ---------------- websocket ---------------- */
const socket = io(WS_URL || "http://localhost:8080", {
	withCredentials: true,
	transports: ["websocket"],
});

socket.on("connect", () => socket.id);

// socket.on("graph:location", (p) => {
//   const idx = devices.value.findIndex((d) => d.id === p.id);
//   if (idx === -1) return;

//   const current = devices.value[idx];

//   // ⛔️ Non aggiornare la posizione se non è dinamico+online
//   if (!isMovable(current)) return;

//   // quando ricevi un device aggiornato o cambi manualmente lo status:
//   const updated = {
//     ...current,
//     status: p.status ?? current.status,
//     // forza statico in UI se non online (coerente col server)
//     is_static:
//       (p.status ?? current.status) !== "online" ? true : current.is_static,
//     location: p.location ?? current.location,
//     updatedAt: p.updated_at ?? current.updatedAt,
//   };

//   // sostituisci l’elemento dell’array (trigger reattivo garantito)
//   devices.value.splice(idx, 1, updated);

//   /* ---------  sposta il marker già montato  --------- */
//   const mk = markerRefs.get(p.id) as MarkerComponent | undefined;
//   if (mk?.leafletObject) {
//     mk.leafletObject.setLatLng(p.location);
//     clusterRef.value?.leafletObject.refreshClusters(mk.leafletObject);
//   }
// });

// Leaflet
globalThis.L = L; // richiesto dal plugin vue-leaflet-markercluster

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
	iconUrl: require("leaflet/dist/images/marker-icon.png"),
	shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const toast = useToast();
const loading = ref(true);
const devices = ref<any[]>([]);
const error = ref<string | null>(null);
const map = ref<any>(null);

// ref per il modale di cambio stato
const showStatusModal = ref(false);
const selectedDevice = ref<any | null>(null);
const tempStatus = ref<boolean | null>(null);
const statusLoading = ref(false);

const statusOptions = [
	{ label: "Dinamico", value: false, class: "on" },
	{ label: "Statico", value: true, class: "off" },
];

const isUpdating = ref(false);

/* ─── Ricerca e Paginazione ─── */
const searchQuery = ref("");
const currentPage = ref(1);
const itemsPerPage = ref(10);
const currentPageInput = ref(1);

const sortBy = ref("updatedAt");
const sortOrder = ref<"asc" | "desc">("desc");

watch(currentPage, (val) => {
	currentPageInput.value = val;
});

const toggleSort = (key: string) => {
	if (sortBy.value === key) {
		sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
	} else {
		sortBy.value = key;
		sortOrder.value = "asc";
	}
};

const jumpToPage = () => {
	let p = parseInt(String(currentPageInput.value));
	if (isNaN(p)) {
		currentPageInput.value = currentPage.value;
		return;
	}
	if (p < 1) p = 1;
	if (p > totalPages.value) p = totalPages.value;
	currentPage.value = p;
	currentPageInput.value = p;
};

const filteredDevices = computed(() => {
	if (!searchQuery.value) return devices.value;
	const q = searchQuery.value.toLowerCase();
	return devices.value.filter((d) => {
		const mode = d.is_static ? "statico" : "dinamico";
		return (
			d.id.toString().toLowerCase().includes(q) ||
			(d.name && d.name.toLowerCase().includes(q)) ||
			(d.status && d.status.toLowerCase().includes(q)) ||
			mode.includes(q)
		);
	});
});

const sortedDevices = computed(() => {
	const result = [...filteredDevices.value];
	return result.sort((a, b) => {
		let valA = a[sortBy.value];
		let valB = b[sortBy.value];

		if (sortBy.value === "updatedAt") {
			valA = valA ? new Date(valA).getTime() : 0;
			valB = valB ? new Date(valB).getTime() : 0;
		}

		if (valA < valB) return sortOrder.value === "asc" ? -1 : 1;
		if (valA > valB) return sortOrder.value === "asc" ? 1 : -1;
		return 0;
	});
});

const paginatedDevices = computed(() => {
	const start = (currentPage.value - 1) * itemsPerPage.value;
	const end = start + itemsPerPage.value;
	return sortedDevices.value.slice(start, end);
});

const totalPages = computed(() => {
	return Math.ceil(filteredDevices.value.length / itemsPerPage.value);
});

// Aggiunge coordinate ai dispositivi filtrati per la mappa
const filteredDevicesWithLocation = computed(() =>
	filteredDevices.value.filter(
		(d) => Array.isArray(d.location) && d.location.length === 2,
	),
);

// Watch for changes in filtered devices to re-center the map
watch(filteredDevicesWithLocation, () => {
	tryFitBounds(true);
});

// Haystack keys removed - now stored securely in backend API
const hasHaystackKeys = computed(() => true); // Backend will handle key availability

// Configurazione mappa
const center = ref<[number, number]>([45.41, 11.88]);
const zoom = ref(5);
const initialBoundsSet = ref(false); // 👈 nuova ref per auto-zoom

const clusterRef = ref<ClusterComponent | null>(null);
// reference per mappa dei tooltip
const tooltipRefs = new Map<string, any>();

const activePopupId = ref<string | null>(null);

// Configurazione cluster
const clusterOptions = {
	spiderfyOnMaxZoom: true,
	showCoverageOnHover: false,
	zoomToBoundsOnClick: true,
	maxClusterRadius: 60,
	iconCreateFunction: (cluster: any) => {
		return L.divIcon({
			html: `<span>${cluster.getChildCount()}</span>`,
			className: "marker-cluster",
			iconSize: L.point(40, 40, true),
		});
	},
};

// URL icone
const iconUrls = {
	online:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
	offline:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
	maintenance:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-orange.png",
	error:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-violet.png",
	default:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-grey.png",
};

const devicesWithLocation = computed(() =>
	devices.value.filter(
		(d) => Array.isArray(d.location) && d.location.length === 2,
	),
);

// Toggles map state manually
function toggleMap() {
	mapCollapsed.value = !mapCollapsed.value;
}

// funzione che permette al marker di muoversi => salvare position, solo se NON statico e status esattamente 'online'
function isMovable(d: any): boolean {
	// ⛔️ NUCLEAR OPTION: Disabilita movimento per tutti, per evitare ghost movement
	// return d && d.is_static === false && d.status === "online";
	return false;
}

/** mappa id → componente <l-marker> */
const markerRefs = new Map<string, any>();

function setMarkerRef(el: any, id: string) {
	if (el) markerRefs.set(id, el as MarkerComponent); // mount
	else markerRefs.delete(id); // unmount
}

function setTooltipRef(el: any, id: string) {
	if (el) tooltipRefs.set(id, el); // mount
	else tooltipRefs.delete(id); // unmount
}

const handlePopupOpen = (deviceId: string) => {
	try {
		activePopupId.value = deviceId;
		const tt = tooltipRefs.get(deviceId);
		tt.leafletObject.getElement().style.display = "none"; // nasconde solo il suo
	} catch (e) {
		console.warn("Error handling popup open:", e);
	}
};

const handlePopupClose = () => {
	try {
		if (activePopupId.value) {
			const tt = tooltipRefs.get(activePopupId.value);
			tt.leafletObject.getElement().style.display = ""; // lo mostra di nuovo
		}
		activePopupId.value = null;
	} catch (e) {
		console.warn("Error handling popup close:", e);
	}
};

/** porta in primo piano il marker */
function focusDevice(deviceId: string) {
	const markerComp = markerRefs.get(deviceId);
	if (!markerComp) return;

	const marker = markerComp.leafletObject;
	const cluster = clusterRef.value?.leafletObject;

	// Chiudi tutti i tooltip prima di focalizzare
	tooltipRefs.forEach((tooltip) => {
		if (tooltip?.leafletObject) {
			tooltip.leafletObject.close();
		}
	});

	if (cluster) {
		cluster.zoomToShowLayer(marker, () => {
			map.value?.leafletObject.panTo(marker.getLatLng() as LatLng);
			// Apri il popup dopo il pan
			setTimeout(() => {
				marker.openPopup();
			}, 300);
		});
	} else {
		map.value?.leafletObject.panTo(marker.getLatLng() as LatLng);
		// Apri il popup dopo il pan
		setTimeout(() => {
			marker.openPopup();
		}, 300);
	}
}

// Crea icona per marker
const getDeviceIcon = (status: string, d?: any) => {
	const movable = d ? isMovable(d) : false;
	return new L.Icon({
		iconUrl: iconUrls[status as keyof typeof iconUrls] || iconUrls.default,
		shadowUrl,
		iconSize: [25, 41],
		iconAnchor: [12, 41],
		popupAnchor: [1, -34],
		className: `marker-icon-${status} ${movable ? "marker-movable" : ""}`,
	});
};

// Centra mappa su posizione
const centerMapOn = (latlng: [number, number]) => {
	if (map.value?.leafletObject) {
		map.value.leafletObject.flyTo(latlng, 12);
	}
	closeActivePopup(); // chiude popup attivi prima di centrare
};

// Callback quando la mappa è pronta
const onMapReady = () => {
	// Puoi accedere all'istanza Leaflet con map.value.leafletObject
	// Crea un pane specifico per i tooltip
	// map.value?.leafletObject.createPane("tooltipPane");
	tryFitBounds(); // 👈 Prova a centrare se i dati sono già pronti
};

const tryFitBounds = async (force = false) => {
	if (initialBoundsSet.value && !force) return;
	if (!filteredDevicesWithLocation.value.length) return;

	await nextTick();

	if (!map.value?.leafletObject) return;

	const validLocs = filteredDevicesWithLocation.value.map((d) => d.location);
	if (!validLocs.length) return;

	const bounds = L.latLngBounds(validLocs);
	if (bounds.isValid()) {
		map.value.leafletObject.fitBounds(bounds, {
			padding: [50, 50],
			maxZoom: 12,
		});
		initialBoundsSet.value = true;
	}
};

function closeActivePopup() {
	try {
		if (map.value?.leafletObject) {
			map.value.leafletObject.closePopup();
		}
		handlePopupClose();
	} catch (e) {
		console.warn("Error closing active popup:", e);
	}
}

// Funzioni di utilità
const getDeviceStatusClass = (d: any): string => {
	const status = d.status || "offline";

	// 1. Rosso se errore o manutenzione esplicita
	if (status === "error" || status === "maintenance") return "error";

	// 2. Arancione se ritado > 15 min
	const last = d.updatedAt ? new Date(d.updatedAt).getTime() : 0;
	const diff = Date.now() - last;
	// console.log("⏱️ Last update diff (ms):", diff);
	if (diff > 15 * 60 * 1000) return "maintenance"; // maintenance style = orange

	// 3. Mappatura standard
	const statusClasses: Record<string, string> = {
		online: "on",
		offline: "off",
		static: "off",
		dynamic: "on",
	};
	return statusClasses[status] || "off";
};

// New Keys, restored for static fetching matching
// New Keys, restored for static fetching matching
const HAYSTACK_KEYS = [
	{ name: "Moak 01 (1PYFKY)", id: "1PYFKY", color: "green", type: "moak" },
	{ name: "Moak 02 (XJZ1XD)", id: "XJZ1XD", color: "green", type: "moak" },
	{ name: "Moak 03 (B0C99B)", id: "B0C99B", color: "green", type: "moak" },
	{ name: "Moak 04 (0VH06Y)", id: "0VH06Y", color: "green", type: "moak" },
];

const HAYSTACK_IDS = HAYSTACK_KEYS.map((k) => k.id);
function isMoakDevice(device: any): boolean {
	if (!device?.name) return false;
	const upper = String(device.name).toUpperCase();
	return HAYSTACK_IDS.some((id) => upper.includes(id));
}

const fetchAndDecrypt = async () => {
	isUpdating.value = true;
	try {
		console.log("[Haystack] Fetching static positions from secure backend...");

		// Piccolo delay per rendere visibile l'animazione spin
		await new Promise((r) => setTimeout(r, 600));

		// Use configured axios (with JWT) to call our backend proxy
		// This keeps the external API private
		const res = await axios.get("/haystack/static-positions");
		const positions = res.data;

		let gotData = false;

		for (const keyDef of HAYSTACK_KEYS) {
			const posData = positions[keyDef.id];
			if (posData && posData.latitude && posData.longitude) {
				gotData = true;

				// Update existing or add new
				let existing = devices.value.find((d) => d.id === keyDef.id);

				// FALLBACK: Handle 0VH06Y vs OVH06Y typo in DB
				if (!existing && keyDef.id === "0VH06Y") {
					existing = devices.value.find((d) => d.id === "OVH06Y");
				}

				const ts = posData.timestamp || Date.now();
				if (existing) {
					existing.latitude = posData.latitude;
					existing.longitude = posData.longitude;
					existing.location = [posData.latitude, posData.longitude];
					existing.updatedAt = ts;
				}
			}
		}

		if (gotData) {
			toast.success(`Aggiornate posizioni Moak`);
		}
	} catch (e) {
		console.error("Update failed", e);
		toast.error("Errore durante l'aggiornamento posizioni");
	} finally {
		isUpdating.value = false;
	}
};

const formatDate = (iso: string) => {
	return dayjs(iso).format("DD/MM/YYYY HH:mm");
};

// const listModules = (d: any) => {
// 	return d.nodes?.map((n: any) => n.label).join(", ") || "—";
// };

// Normalizza i nomi dei moduli (da nodes[].label) in chiavi “stabili”
const normalizeModule = (raw: string): { key: string; text: string } => {
	const txt = (raw || "").trim();
	const s = txt.toLowerCase();

	// sinonimi → chiave
	if (/(mother\s*board|motherboard|mb)/.test(s))
		return { key: "motherboard", text: "Motherboard" };
	if (/lora/.test(s)) return { key: "lora", text: "LORa" };
	if (/lte\s*\/?\s*5g|5g|lte/.test(s)) return { key: "lte5g", text: "LTE/5G" };
	if (/sat|satellite/.test(s)) return { key: "sat", text: "SAT" };
	if (/wifi|wi\-?fi/.test(s)) return { key: "wifi", text: "Wi-Fi" };
	if (/ble|bluetooth/.test(s)) return { key: "ble", text: "BLE" };
	if (/gps|gnss/.test(s)) return { key: "gps", text: "GPS" };
	if (/camera|cam/.test(s)) return { key: "camera", text: "Camera" };
	if (/ai|ml|npu/.test(s)) return { key: "ai", text: "AI" };
	if (/battery|batt/.test(s)) return { key: "battery", text: "Battery" };
	if (/solar|pv|panel/.test(s)) return { key: "solar", text: "Solar" };
	if (/storage|sd|ssd|flash/.test(s))
		return { key: "storage", text: "Storage" };

	// fallback: chiave “slug” dal testo originale
	return {
		key: txt
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-|-$|/g, ""),
		text: raw,
	};
};

// Estrae moduli unici dal device (d.nodes[].label)
const getModuleLabels = (d: any): Array<{ key: string; text: string }> => {
	const src = d?.nodes?.map((n: any) => n?.label).filter(Boolean) || [];
	const map = new Map<string, { key: string; text: string }>();
	for (const label of src) {
		const mod = normalizeModule(String(label));
		if (!map.has(mod.key)) map.set(mod.key, mod);
	}
	return Array.from(map.values());
};

function getLatLng(loc: any): [number, number] | null {
	if (
		Array.isArray(loc) &&
		loc.length === 2 &&
		loc.every((n) => typeof n === "number")
	) {
		return [loc[0], loc[1]];
	}
	if (loc && typeof loc.lat === "number" && typeof loc.lng === "number") {
		return [loc.lat, loc.lng];
	}
	return null;
}

function formatCoords(loc: any): string {
	const ll = getLatLng(loc);
	if (!ll) return "—";
	const [lat, lng] = ll;
	return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
}

// opzionale: clic sulle coordinate per centrare la mappa
function centerIfPossible(d: any) {
	const ll = getLatLng(d.location);
	if (!ll) return;
	centerMapOn(ll as [number, number]);
}

const loadDevices = async () => {
	loading.value = true;
	try {
		// Carica info utente se non già caricate
		if (!me.value.id) {
			const { data: user } = await axios.get("/auth/me");
			me.value = user;
		}

		const { data, status } = await axios.get("/devices/get-all-graphs", {
			withCredentials: true,
		});

		if (status === 204) {
			devices.value = [];
			toast.info("Nessun dispositivo trovato", {
				position: "top-right",
				duration: 2000,
			});
			return;
		}

		// Filtra dispositivi attivi
		devices.value = (data ?? []).filter((g: any) => g.is_archived === false);

		// ──────────────── EXTERNAL STATIC POSITIONS (MOAK) ────────────────
		try {
			const extData = await fetchExternalStaticPositions();
			if (extData) {
				devices.value.forEach((d) => {
					// Solo per dispositivi statici
					if (!d.is_static) return;

					const candidates = [d.name, d.vin, d.serial_number, d.code].filter(
						Boolean,
					);

					let match = null;
					// Direct match on ID
					for (const c of candidates) {
						if (extData[c]) {
							match = extData[c];
							break;
						}
						// Partial match via key iteration
						const partialKey = Object.keys(extData).find((k) => c.includes(k));
						if (partialKey) {
							match = extData[partialKey];
							break;
						}
					}

					if (match && match.latitude && match.longitude) {
						d.location = [match.latitude, match.longitude];
						if (match.timestamp) {
							d.updatedAt = match.timestamp;
						} else {
							d.updatedAt = Date.now();
						}
					}
				});
			}
		} catch (e) {
			console.warn("Failed to merge external static positions", e);
		}
		// ──────────────────────────────────────────────────────────────────

		// ──────────────── DYNAMIC DEVICES HYDRATION ────────────────
		// Forza il refresh della posizione dall'ultimo log per TUTTI i device dinamici
		// per evitare disallineamenti con la tabella devices (che potrebbe avere dati vecchi).
		const dynamicDevices = devices.value.filter((d) => !d.is_static);

		if (dynamicDevices.length > 0) {
			console.log(
				`[Dashboard] Hydrating ${dynamicDevices.length} dynamic devices from logs...`,
			);

			await Promise.all(
				dynamicDevices.map(async (d) => {
					try {
						// Prima controlla se c'è latest_data (magari location era null ma i dati ci sono)
						if (d.latest_data && d.latest_data.latitude) {
							d.location = [d.latest_data.latitude, d.latest_data.longitude];
							if (d.latest_data.timestamp)
								d.updatedAt = d.latest_data.timestamp * 1000;
							return;
						}

						// Altrimenti chiamata API per storico
						const logsRes = await axios.get(`/track/${d.id}/logs`, {
							params: {
								limit: 1,
								orderBy: "timestamp",
								orderDirection: "DESC",
							},
						});
						const lastLog = logsRes.data?.logs?.[0];

						if (lastLog && lastLog.latitude && lastLog.longitude) {
							d.location = [lastLog.latitude, lastLog.longitude];
							// Se il timestamp arriva in secondi, converti in ms
							if (lastLog.timestamp) {
								d.updatedAt =
									lastLog.timestamp.toString().length === 10
										? lastLog.timestamp * 1000
										: lastLog.timestamp;
							}
							d.latest_data = lastLog;
							console.log(`[Dashboard] Recovered location for ${d.name}`);
						}
					} catch (e) {
						console.warn(
							`[Dashboard] Failed to recover location for ${d.name}`,
							e,
						);
					}
				}),
			);
		}
		// ────────────────────────────────────────────────────────

		// Auto-center mappa
		tryFitBounds();
	} catch (e: any) {
		error.value = e.response?.data?.details || "Errore caricamento";
		toast.error("Errore nel caricamento dei dispositivi", {
			position: "top-right",
			duration: 2000,
		});
	} finally {
		loading.value = false;
	}
};

/* ───────── External Data Fetcher ───────── */
async function fetchExternalStaticPositions() {
	try {
		// [FIX] Use backend proxy
		const res = await axios.get("/haystack/static-positions", {
			withCredentials: true,
		});
		return res.data;
	} catch (e) {
		console.warn("External static positions fetch failed", e);
		return null;
	}
}

function openData(device: any) {
	router.push({ name: "Data", params: { deviceId: device.id } });
}

function selectStatus(is_static: boolean) {
	tempStatus.value = is_static;
}

async function confirmStatusChange() {
	if (!selectedDevice.value || tempStatus.value === null) return;

	try {
		statusLoading.value = true;

		const { id, name } = selectedDevice.value;
		const payload = { is_static: tempStatus.value };

		await axios.patch(`/devices/${id}/change-is-static`, payload, {
			withCredentials: true,
		});

		// ✅ chiudi il modale prima del toast
		closeStatusModal();

		toast.success(
			`Il dispositivo ${name || id} ora è ${
				payload.is_static ? "Statico" : "Dinamico"
			}`,
			{ position: "top-right", duration: 2200 },
		);

		// Aggiorna subito lo stato locale per feedback immediato
		const dev = devices.value.find((d) => d.id === id);
		if (dev) {
			dev.is_static = payload.is_static;
		}

		// Ricarica la lista per coerenza e riapplica i fix statici
		await loadDevices();
		await fetchAndDecrypt();
	} catch (e: any) {
		// Check for permission error (401 or specific message)
		const isPermissionError =
			e.response?.status === 401 ||
			(e.response?.data?.message &&
				e.response.data.message.includes("Non hai i permessi"));

		if (isPermissionError) {
			// Capture device BEFORE closing the modal (which clears selectedDevice)
			permissionDevice.value = selectedDevice.value;
			failedPermissionType.value = "change_mode";

			closeStatusModal();

			// Show error toast to explain WHY the modal opened (User Request)
			const msg = extractServerError(e);
			toast.error(msg, { position: "top-right", duration: 4000 });

			// Open Request Modal with delay
			setTimeout(() => {
				showPermissionModal.value = true;
			}, 2500);
			return;
		}

		// ✅ messaggio preciso dal server + chiusura modale
		const msg = extractServerError(e);
		closeStatusModal();

		// Mostra il toast con un leggero ritardo (come in DevicesList.vue)
		setTimeout(() => {
			toast.error(msg, { position: "top-right", duration: 4000 });
		}, 300);
	} finally {
		statusLoading.value = false;
	}
}

function cancelStatusChange() {
	showStatusModal.value = false;
	tempStatus.value = null;
	selectedDevice.value = null;
}

function openStatusModal(device: any) {
	selectedDevice.value = device;
	tempStatus.value = device.is_static;
	showStatusModal.value = true;
}

function closeStatusModal() {
	showStatusModal.value = false;
	tempStatus.value = null;
	selectedDevice.value = null;
}

function extractServerError(err: any): string {
	// prova i campi più comuni del tuo API handler
	return (
		err?.response?.data?.message ||
		err?.response?.data?.details ||
		err?.response?.data?.error ||
		err?.message ||
		"Errore cambio stato"
	);
}

watch(mapCollapsed, async () => {
	await nextTick();
	// aspetta la durata della transition (match al CSS sotto)
	setTimeout(() => {
		try {
			map.value?.leafletObject?.invalidateSize(false);
		} catch {}
	}, 260);
});

onMounted(async () => {
	await loadDevices();
	await fetchAndDecrypt(); // Auto-load static positions (AFTER devices are loaded)
	const t = setInterval(async () => {
		await loadDevices();
		await fetchAndDecrypt();
	}, 10 * 60000);

	onBeforeUnmount(() => {
		clearInterval(t);
	});
});

/* opzionale: chiusura quando il componente si distrugge */
/* opzionale: chiusura quando il componente si distrugge */
onBeforeUnmount(() => {
	socket.off("graph:location");
	socket.off("connect");
	socket.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[12] || (_cache[12] = _createElementVNode("span", null, "Dashboard", -1)),
      _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)),
      (showCrumbBell.value)
        ? (_openBlock(), _createBlock(NotificationBell, {
            key: 0,
            placement: "header"
          }))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Caricamento…"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
        : (!devices.value.length && !loading.value && !error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Nessun dispositivo presente "))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                id: "step-map",
                class: _normalizeClass(["map-container", { 'is-collapsed': mapCollapsed.value }])
              }, [
                _createVNode(_unref(LMap), {
                  ref_key: "map",
                  ref: map,
                  zoom: zoom.value,
                  center: center.value,
                  options: { zoomControl: false },
                  onReady: onMapReady
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(LTileLayer), {
                      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                      attribution: "© OpenStreetMap contributors"
                    }),
                    _createVNode(_unref(LMarkerClusterGroup), {
                      ref_key: "clusterRef",
                      ref: clusterRef,
                      options: clusterOptions
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDevicesWithLocation.value, (device) => {
                          return (_openBlock(), _createBlock(_unref(LMarker), {
                            key: device.id,
                            "lat-lng": device.location,
                            icon: getDeviceIcon(device.status, device),
                            ref_for: true,
                            ref: (el) => setMarkerRef(el, device.id),
                            onPopupopen: ($event: any) => (handlePopupOpen(device.id)),
                            onPopupclose: handlePopupClose
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(LTooltip), {
                                ref_for: true,
                                ref: (el) => setTooltipRef(el, device.id),
                                options: {
								permanent: true,
								direction: 'top',
								offset: [0, -40],
								opacity: 0.9,
								className: 'marker-tooltip',
								interactive: false,
							}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(device.name || device.id), 1)
                                ]),
                                _: 2
                              }, 1536),
                              _createVNode(_unref(LPopup), { options: { className: 'device-frame' } }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                      class: "popup-close",
                                      onClick: closeActivePopup
                                    }, [
                                      _createVNode(_unref(CloseIcon))
                                    ]),
                                    _createElementVNode("h4", null, _toDisplayString(device.name || device.id), 1),
                                    _createElementVNode("p", _hoisted_7, [
                                      _createElementVNode("span", null, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["status-dot", getDeviceStatusClass(device)])
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(device.status), 1)
                                      ]),
                                      _createElementVNode("button", {
                                        class: "btn-action-labeled",
                                        onClick: ($event: any) => (openData(device))
                                      }, [
                                        _createVNode(_unref(DataIcon)),
                                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Data", -1))
                                      ], 8, _hoisted_8)
                                    ]),
                                    (getModuleLabels(device).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getModuleLabels(device), (m) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: m.key,
                                              class: _normalizeClass(['label', `label--${m.key}`])
                                            }, _toDisplayString(m.text), 3))
                                          }), 128))
                                        ]))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_10, "Moduli connessi: —")),
                                    _createElementVNode("p", null, "Ultimo aggiornamento: " + _toDisplayString(formatDate(device.updatedAt)), 1),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (centerMapOn(device.location))
                                      }, " Centra mappa ", 8, _hoisted_12)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["lat-lng", "icon", "onPopupopen"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }, 8, ["zoom", "center"]),
                (hasHaystackKeys.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["map-refresh-pill", { updating: isUpdating.value }]),
                      disabled: isUpdating.value,
                      onClick: fetchAndDecrypt,
                      title: "Aggiorna posizioni"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["pill-icon", { spin: isUpdating.value }]),
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" }, null, -1)
                      ]))], 2)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(isUpdating.value ? 'Aggiornamento…' : 'Aggiorna posizioni'), 1)
                    ], 10, _hoisted_13))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "map-fab",
                  onClick: toggleMap,
                  title: mapCollapsed.value ? 'Espandi mappa' : 'Contrai mappa',
                  "aria-label": mapCollapsed.value ? 'Espandi mappa' : 'Contrai mappa'
                }, [
                  (mapCollapsed.value)
                    ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(ChevronUpIcon), { key: 1 }))
                ], 8, _hoisted_15)
              ], 2),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _createElementVNode("table", _hoisted_17, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSort('id'))),
                        class: "sortable"
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[16] || (_cache[16] = _createTextVNode(" ID ", -1)),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(
										sortBy.value === 'id'
											? sortOrder.value === 'asc'
												? _unref(ChevronUpIcon)
												: _unref(ChevronDownIcon)
											: 'span'
									), { class: "sort-icon" }))
                        ])
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("th", null, "Nome", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("th", null, null, -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("th", null, "Status", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("th", null, "Dinamico/Statico", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("th", null, "Moduli connessi", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("th", null, "Posizione attuale", -1)),
                      _createElementVNode("th", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort('updatedAt'))),
                        class: "sortable"
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _cache[17] || (_cache[17] = _createTextVNode(" Last update ", -1)),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(
										sortBy.value === 'updatedAt'
											? sortOrder.value === 'asc'
												? _unref(ChevronUpIcon)
												: _unref(ChevronDownIcon)
											: 'span'
									), { class: "sort-icon" }))
                        ])
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("th", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_20, [
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                            type: "text",
                            placeholder: "Cerca per ID, Nome o Status...",
                            class: "search-input",
                            onInput: _cache[3] || (_cache[3] = ($event: any) => (currentPage.value = 1))
                          }, null, 544), [
                            [_vModelText, searchQuery.value]
                          ])
                        ])
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDevices.value, (d, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: d.id,
                        class: _normalizeClass(['device-row', i % 2 && 'alt']),
                        onClick: ($event: any) => (focusDevice(d.id)),
                        tabindex: "0"
                      }, [
                        _createElementVNode("td", _hoisted_24, _toDisplayString(d.id), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(d.name || "—") + " ", 1),
                          (d.is_shared)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "shared-device-badge",
                                title: `Condiviso da ${d.shared_by_name || 'Admin'}`
                              }, " 🔗 Condiviso ", 8, _hoisted_25))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("button", {
                            class: "btn-action-labeled",
                            title: "Data",
                            onClick: _withModifiers(($event: any) => (openData(d)), ["stop"])
                          }, [
                            _createVNode(_unref(DataIcon)),
                            _cache[25] || (_cache[25] = _createElementVNode("span", null, "Data", -1))
                          ], 8, _hoisted_27)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-dot", getDeviceStatusClass(d)])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(d.status), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "status-btn",
                            onClick: _withModifiers(($event: any) => (openStatusModal(d)), ["stop"]),
                            title: `Cambia modalità (attuale: ${
									d.is_static ? 'Statico' : 'Dinamico'
								})`
                          }, [
                            (d.is_static)
                              ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                                  key: 0,
                                  icon: _unref(faLocationCrosshairs),
                                  class: "status-icon static"
                                }, null, 8, ["icon"]))
                              : (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                                  key: 1,
                                  icon: _unref(faArrowsUpDownLeftRight),
                                  class: "status-icon dynamic"
                                }, null, 8, ["icon"])),
                            _createTextVNode(" " + _toDisplayString(d.is_static ? "Statico" : "Dinamico") + " ", 1),
                            _createVNode(_unref(ChevronDownIcon), { class: "status-edit-icon" })
                          ], 8, _hoisted_28)
                        ]),
                        _createElementVNode("td", null, [
                          (getModuleLabels(d).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getModuleLabels(d), (m) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: m.key,
                                    class: _normalizeClass(['label', `label--${m.key}`])
                                  }, _toDisplayString(m.text), 3))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          (getLatLng(d.location))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "coords",
                                onClick: _withModifiers(($event: any) => (centerIfPossible(d)), ["stop"])
                              }, _toDisplayString(formatCoords(d.location)), 9, _hoisted_32))
                            : (_openBlock(), _createElementBlock("span", _hoisted_33, "—")),
                          (!isMoakDevice(d))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "edit-coords-btn",
                                title: getLatLng(d.location) ? 'Modifica coordinate' : 'Inserisci nuove coordinate',
                                onClick: _withModifiers(($event: any) => (openLocationModal(d)), ["stop"])
                              }, [...(_cache[26] || (_cache[26] = [
                                _createElementVNode("svg", {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                                  _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4Z" })
                                ], -1)
                              ]))], 8, _hoisted_34))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                class: "edit-coords-btn",
                                title: "Aggiorna posizione da Moak",
                                disabled: isUpdating.value,
                                onClick: _withModifiers(fetchAndDecrypt, ["stop"])
                              }, [
                                (_openBlock(), _createElementBlock("svg", {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  class: _normalizeClass({ spin: isUpdating.value })
                                }, [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("polyline", { points: "23 4 23 10 17 10" }, null, -1),
                                  _createElementVNode("polyline", { points: "1 20 1 14 7 14" }, null, -1),
                                  _createElementVNode("path", { d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" }, null, -1)
                                ]))], 2))
                              ], 8, _hoisted_35))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(formatDate(d.updatedAt)), 1)
                      ], 10, _hoisted_23))
                    }), 128)),
                    (searchQuery.value && !filteredDevices.value.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                          _createElementVNode("td", _hoisted_37, " Nessun risultato trovato per \"" + _toDisplayString(searchQuery.value) + "\" ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 512), [
                [_vShow, devices.value.length]
              ]),
              (totalPages.value > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("button", {
                      disabled: currentPage.value === 1,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (currentPage.value = 1)),
                      class: "btn-pagination",
                      title: "Vai alla prima pagina"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAnglesLeft) }, null, 8, ["icon"])
                    ], 8, _hoisted_39),
                    _createElementVNode("button", {
                      disabled: currentPage.value === 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (currentPage.value--)),
                      class: "btn-pagination",
                      title: "Vai alla pagina precedente"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAngleLeft) }, null, 8, ["icon"])
                    ], 8, _hoisted_40),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", null, "Pagina", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentPageInput).value = $event)),
                        onKeyup: _withKeys(jumpToPage, ["enter"]),
                        onBlur: jumpToPage,
                        min: "1",
                        max: totalPages.value,
                        class: "jump-input"
                      }, null, 40, _hoisted_42), [
                        [_vModelText, currentPageInput.value]
                      ]),
                      _createElementVNode("span", null, "di " + _toDisplayString(totalPages.value), 1)
                    ]),
                    _createElementVNode("button", {
                      disabled: currentPage.value === totalPages.value,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (currentPage.value++)),
                      class: "btn-pagination",
                      title: "Vai alla pagina successiva"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAngleRight) }, null, 8, ["icon"])
                    ], 8, _hoisted_43),
                    _createElementVNode("button", {
                      disabled: currentPage.value === totalPages.value,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (currentPage.value = totalPages.value)),
                      class: "btn-pagination",
                      title: "Vai all'ultima pagina"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAnglesRight) }, null, 8, ["icon"])
                    ], 8, _hoisted_44)
                  ]))
                : _createCommentVNode("", true)
            ])),
    (showStatusModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Cambio modalità dispositivo", -1)),
            _createElementVNode("p", _hoisted_47, [
              _cache[29] || (_cache[29] = _createTextVNode(" Seleziona la nuova modalità per ", -1)),
              _createElementVNode("strong", null, _toDisplayString(selectedDevice.value?.name || selectedDevice.value?.id), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (status) => {
                return _createElementVNode("button", {
                  key: status.label,
                  onClick: ($event: any) => (selectStatus(status.value)),
                  class: _normalizeClass({ active: tempStatus.value === status.value })
                }, [
                  (status.value === true)
                    ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                        key: 0,
                        icon: _unref(faLocationCrosshairs),
                        class: "status-icon static"
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                        key: 1,
                        icon: _unref(faArrowsUpDownLeftRight),
                        class: "status-icon dynamic"
                      }, null, 8, ["icon"])),
                  _createTextVNode(" " + _toDisplayString(status.label), 1)
                ], 10, _hoisted_49)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                disabled: tempStatus.value === null || statusLoading.value,
                onClick: confirmStatusChange
              }, " Conferma ", 8, _hoisted_51),
              _createElementVNode("button", {
                disabled: statusLoading.value,
                onClick: cancelStatusChange
              }, " Annulla ", 8, _hoisted_52)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showLocationModal.value)
      ? (_openBlock(), _createBlock(LocationModal, {
          key: 5,
          deviceName: locationModalDevice.value?.name,
          deviceId: locationModalDevice.value?.id,
          location: locationModalDevice.value?.location,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (showLocationModal.value = false)),
          onCopy: copyLocationCoords,
          onSaved: _cache[10] || (_cache[10] = (loc, updatedAt) => { if (locationModalDevice.value) { locationModalDevice.value.location = loc; locationModalDevice.value.updatedAt = updatedAt; } showLocationModal.value = false; })
        }, null, 8, ["deviceName", "deviceId", "location"]))
      : _createCommentVNode("", true),
    (showPermissionModal.value)
      ? (_openBlock(), _createBlock(PermissionRequestModal, {
          key: 6,
          deviceId: permissionDevice.value?.id,
          deviceName: permissionDevice.value?.name,
          permissionType: failedPermissionType.value,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (showPermissionModal.value = false))
        }, null, 8, ["deviceId", "deviceName", "permissionType"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})